import { useApplicantAttributionContext } from '../context/ApplicantAttributionContext';

export const useApplicantAttribution = () => {
    const { attribution } = useApplicantAttributionContext();
    return attribution;
};
